<footer class="footer section-inset-y">
  <div class="container">
    <div class="footer__header justify-content-center">
      <div class="footer__header__links footer-column col-12 col-lg-3">
        <div class="footer-logo mb-3">
          <a class="outline-focus" [routerLink]="['/']">
            <span class="sr-only">Patiëntenvereniging voor Stofwisselingsziekten</span>
          </a>
        </div>
        <div class="footer__socials">
          <ul class="footer__socials__list">
            <li>
              <a class="button button-icon button-social button--sm mr-2" href="{{ 'footer-social-facebook' | fromDictionary }}">
                <fstr-icon [ariaHidden]="true" [anchor]="'icon-facebook'"></fstr-icon>
                <span class="sr-only">Facebook</span>
              </a>
            </li>
            <li>
              <a class="button button-icon button-social button--sm mr-2" href="{{ 'footer-social-linkedin' | fromDictionary }}">
                <fstr-icon [ariaHidden]="true" [anchor]="'icon-linkedin'"></fstr-icon>
                <span class="sr-only">LinkedIn</span>
              </a>
            </li>
            <li>
              <a class="button button-icon button-social button--sm mr-2" href="mailto:{{ 'footer-social-email' | fromDictionary }}">
                <fstr-icon [ariaHidden]="true" [anchor]="'icon-email'"></fstr-icon>
                <span class="sr-only">Email</span>
              </a>
            </li>
            <li>
              <a class="button button-icon button-social button--sm mr-2" href="{{ 'footer-social-instagram' | fromDictionary }}">
                <fstr-icon [ariaHidden]="true" [anchor]="'icon-instagram'"></fstr-icon>
                <span class="sr-only">Instagram</span>
              </a>
            </li>
            <li>
              <a class="button button-icon button-social button--sm" href="{{ 'footer-social-youtube' | fromDictionary }}">
                <fstr-icon [ariaHidden]="true" [anchor]="'icon-youtube'"></fstr-icon>
                <span class="sr-only">Youtube</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer__header__info row">
        <div class="footer__header__donation footer-column col-12 col-sm-5 col-lg-7">
          <div class="footer__cta text-white">
            <p class="footer__cta__text font-weight-bold">{{ 'footer-cta-tekst' | fromDictionary }}</p>
            <!-- <button class="button footer__cta__button">{{ 'footer-knop-tekst' | fromDictionary }}</button> -->
            <a [href]="'donateur-link' | fromDictionary" class="button button--white">
              <span>{{ 'footer-knop-tekst' | fromDictionary }}</span>
            </a>
          </div>
          <div class="footer__header__donation text-white mt-4">
            <ul class="footer__header__donation__list">
              <li class="font-weight-bold">Eenmalige donatie</li>
              <li>{{ 'footer-donatie-iban' | fromDictionary }}</li>
              <li>{{ 'footer-donatie-ternamevan' | fromDictionary }}</li>
            </ul>
          </div>
        </div>

        <div class="footer__header__contact text-white footer-column col-12 col-sm-5 col-lg-5">
          <ul>
            <li class="font-weight-bold">Bezoekadres</li>
            <li>{{ 'footer-bezoekadres-straat' | fromDictionary }}</li>
            <li>{{ 'footer-bezoekadres-postcode' | fromDictionary }}</li>
          </ul>

          <ul>
            <li class="font-weight-bold">Patiëntenvereniging VKS</li>
            <li>{{ 'footer-vks-postbus' | fromDictionary }}</li>
            <li>{{ 'footer-vks-postcode' | fromDictionary }}</li>
            <li>{{ 'footer-vks-telefoon' | fromDictionary }}</li>
            <li>
              <a class="text-white" [href]="'mailto:' + ('footer-vks-email' | fromDictionary)">{{ 'footer-vks-email' | fromDictionary }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer__partners row justify-content-center mt-4 mb-4">
      <ul class="footer__partners__list d-flex flex-row align-items-center">
        <li class="footer__partners__list__item">
          <a class="outline-focus" [href]="'footer-anbi-url' | fromDictionary">
            <img [src]="'/assets/img/logo-anbi.png'" alt="Algemeen nut bewegende instelling" />
          </a>
        </li>
        <li class="footer__partners__list__item">
          <a class="outline-focus" [href]="'footer-metakids-url' | fromDictionary">
            <img [src]="'/assets/img/logo-metakids.png'" alt="Metakids" />
          </a>
        </li>
        <li class="footer__partners__list__item">
          <a class="outline-focus" [href]="'footer-stofwisselkracht-url' | fromDictionary">
            <img [src]="'/assets/img/logo-stofwissel-kracht.png'" alt="Stofwisselkracht" />
          </a>
        </li>
      </ul>
    </div>
    <div class="footer__info row justify-content-center">
      <ul class="footer__info__list d-flex text-center flex-column flex-sm-column flex-lg-row text-white">
        <li class="footer__info__list__item">&copy; {{ currentYear }} Patiëntenvereniging voor Stofwisselingsziekten (VKS)</li>
        <li class="footer__info__list__item">
          <a class="text-white outline-focus" [href]="'footer-privacybeleid-url' | fromDictionary">
            {{ 'footer-privacybeleid-tekst' | fromDictionary }}
          </a>
        </li>
        <li class="footer__info__list__item">
          <button class="text-white outline-focus contrast-button" (click)="contrastMode()">
            <fstr-icon [ariaHidden]="true" class="icon-xs" anchor="icon-contrast"></fstr-icon>
            @if (!contrast) {
              <span>Verhoog contrast</span>
            }
            @if (contrast) {
              <span>Verlaag contrast</span>
            }
          </button>
        </li>
      </ul>
    </div>
  </div>
</footer>
